import { Replacement, PipeObject, Token } from '../types';

const headingRegex = /(?<head>#+\s*)(?<heading>.*)/i;

export const Headers = () => {
  return ({ input, lex, data }: PipeObject) => {
    let obj: Token;
    let replacements: Replacement[] = [];
    while ((obj = lex.next())) {
      let headerStart, headerEnd;
      if (obj.token === 'header') {
        headerStart = obj;
        while ((obj = lex.next())) {
          if (obj.token === 'new_line') {
            headerEnd = obj;
            break;
          }
        }

        const value = input.substring(headerStart?.begin, headerEnd?.end);
        if (value) {
          const match = value.match(headingRegex);
          const headerLength = match && match?.groups?.head.trim().length;
          const style =
            headerLength && headerLength > 2 ? 'margin-bottom:0px;' : null;

          replacements.push({
            searchValue: value,
            replaceValue: `<h${headerLength}${
              style ? ` style=${style}` : ''
            }>${value.substring(headerLength || 0)}</h${headerLength}>`,
          });
        }
      }
    }

    for (const rep of replacements) {
      input = input.replace(rep.searchValue, rep.replaceValue);
    }

    return { input, lex, data };
  };
};
